<template>
      <svg class='uni-logo' viewBox="0 0 48 48">
        <rect width="48" height="48" rx="7.86"/>
        <ellipse cx="36.71" cy="13.63" rx="3.11" ry="2.92"/>
        <path class="cls-3" d="M34.21,18.5v8.24L25.4,18.5H21v8.63a3.85,3.85,0,1,1-7.7,0V18.5H7.92v8.42a9.37,9.37,0,0,0,9.27,9.45,9.35,9.35,0,0,0,9.25-8.84l8.81,7.94h4.36v-17Z"/>
      </svg>
</template>

<script>
    export default {
        name: "Uni-logo",
    }
</script>

<style scoped lang="scss">


  svg{
    height: 35px;
    width: 35px;
    rect{
      fill:var(--surface-color-light);
    }
    ellipse{
      fill: var(--color-primary);
    }
    path{
      fill: var(--color-grey-light);
    }
  }


@media (prefers-color-scheme: dark){
  svg{
    rect{
      fill: var(--color-white);
    }
  }
}
</style>
